/**
 * Лёгкая обёртка для SVG-спрайта.
 * Нет JS-бандла для иконок — браузер рендерит нативно через <use>.
 *
 * Использование:
 *   import { Icon } from './Icon'
 *   <Icon id="gen-audio" size={14} />
 *   <Icon id="gen-send" size={18} color="currentColor" />
 *   <Icon id="gen-audio-off" width={20} height={20} />
 *
 * Все id: gen-add, gen-image, gen-swap, gen-video, gen-close, gen-eye-off, gen-lock, gen-check,
 *   gen-aspect-ratio, gen-aspect-auto, gen-duration, gen-audio, gen-audio-off,
 *   gen-negative, gen-optimizer, gen-resolution, gen-speed, gen-version,
 *   gen-stylization, gen-safety, gen-format, gen-settings, gen-send, gen-spin
 */

import type React from 'react'

interface IconProps {
	id: string
	size?: number
	width?: number
	height?: number
	color?: string
	className?: string
	style?: React.CSSProperties
	'aria-hidden'?: boolean
}

export function Icon({
	id,
	size,
	width,
	height,
	color = 'currentColor',
	className,
	style,
	'aria-hidden': ariaHidden = true,
}: IconProps) {
	const w = width ?? size ?? 16
	const h = height ?? size ?? 16

	return (
		<svg
			width={w}
			height={h}
			aria-hidden={ariaHidden}
			className={className}
			style={{ color, flexShrink: 0, ...style }}
		>
			<use href={`#${id}`} />
		</svg>
	)
}
